import facebookIcon from "../../../public/assets/FacebookLogo.svg";
import instaIcon from "../../../public/assets/InstagramLogo.svg";
import linkIcon from "../../../public/assets/LinkedIn.png";
import logo from "../../../public/assets/loogo.png";
import powerBy from "../../../public/assets/powerby.png";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
export const Footer = ()=> {
    const [t, i18n] = useTranslation();
    return createPortal(
        <footer className="footer">
        <div className="footer-content">
          <div className="logo">
            <img src={logo} alt="LATAM Shipping Logo" width={60} height={60} />
          </div>
          <div className="social-info-container">
            <div className="copyright">
   
              © 2024 latan.shipping. All rights reserved.
            </div>
            <div className="powered-by">
              <span>Power by</span>
              <img src={powerBy} alt="MiEncarguito Logo" />
            </div>
            <div className="contacts">
              <span>{t('contact_us')}</span>
              <img src={facebookIcon} className="social-icon" />
              <img src={instaIcon} className="social-icon" />
              <img src={linkIcon} className="social-icon" />
            </div>
          </div>
        </div>
      </footer>
        ,
        document.getElementById("footer-root")
    );
}